import Str from "./Str";

export default class Cookie {
    static get(key, fallback = null) {
        return Str.between(document.cookie, `${key}=`, ';') ?? fallback;
    }
}
